import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SimpleResponse } from '../objetos/simple-response';
import { ConexionesService } from './conexiones.service';
import { environment } from '../../../environments/environment';
import type { PreferenciaTema } from './tema.service';

export interface PreferenciasUsuario {
  tema: PreferenciaTema;
  filtros: Record<string, any>;
}

@Injectable({
  providedIn: 'root',
})
export class PreferenciasUsuarioService {
  private baseUrl = '';

  constructor(
    private http: HttpClient,
    private conexionesService: ConexionesService,
  ) {
    conexionesService.conexionesRO.subscribe((res) => {
      if (res && res.length > 0) {
        const apiNombre = environment.conexiones_nombre.auth;
        const conexion: any = conexionesService.buscarConexion(apiNombre);
        this.baseUrl = conexion?.URL;
      }
    });
  }

  obtenerPreferencias(): Observable<SimpleResponse> {
    return this.http.get<SimpleResponse>(`${this.baseUrl}/api/usuarios-preferencias`);
  }

  actualizarTema(tema: PreferenciaTema): Observable<SimpleResponse> {
    return this.http.put<SimpleResponse>(`${this.baseUrl}/api/usuarios-preferencias/tema`, { tema });
  }

  actualizarFiltrosPagina(pagina: string, filtros: Record<string, any>): Observable<SimpleResponse> {
    return this.http.put<SimpleResponse>(`${this.baseUrl}/api/usuarios-preferencias/filtros`, {
      pagina,
      filtros,
    });
  }

  eliminarFiltrosPagina(pagina: string): Observable<SimpleResponse> {
    return this.http.delete<SimpleResponse>(`${this.baseUrl}/api/usuarios-preferencias/filtros`, {
      body: { pagina },
    });
  }
}
